import { t } from "i18next";

export const phoneValidator = (phone) => {
    if (!phone) {
        return false;
    }

    const whiteList = /^\+?([0-9]*)$/;
    if (!whiteList.test(phone)) {
        return t("phoneEnglish.label");
    }
    if (phone[0] !== "+")
        if (phone.length !== 11 || phone[0] !== "0" || phone[1] !== "9") {
            return t("phoneNotCurrect.label");
        }
    return true;
};

export const copyToClipboard = (val) => {
    navigator.clipboard.writeText(val);
};

export const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

export const getLanguageCaption = (language) => {
    switch (language) {
        case "en":
            return t(
                "Organizational.Settings.NewInformationField.Language.English.Drop.Filter"
            );
        case "ar":
            return t(
                "Organizational.Settings.NewInformationField.Language.Arabic.Drop.Filter"
            );

        case "fa":
            return t(
                "Organizational.Settings.NewInformationField.Language.Persian.Drop.Filter"
            );
    }
};

export const featureTypeList = [
    null,
    t("Organizational.Settings.NewInformationField.Type.Text.Drop.Filter"),
    t("Organizational.Settings.NewInformationField.Type.File.Drop.Filter"),
    t("Organizational.Settings.NewInformationField.Type.Picture.Drop.Filter"),
    t("Organizational.Settings.NewInformationField.Type.Numerical.Drop.Filter"),
    t("Organizational.Settings.NewInformationField.Type.Options.Drop.Filter"),
    t("Organizational.Settings.NewInformationField.Type.Link.Drop.Filter"),
];
export const criteriaTypeList = [
    null,
    t("criteria.type.numeral"),
    t("criteria.type.text"),
    t("criteria.type.emoji"),
    t("criteria.type.star"),
    t("criteria.type.range"),
];

export function scrollIntoView(selector, offset = 0) {
    window.scroll(0, document.querySelector(selector).offsetTop - offset);
}

function optionLabel(option) {
    if (option && typeof option === "object") {
        return option.label ?? option.value ?? "";
    }
    return option;
}

// Option-type features are meant to hold a JSON array, but imported and seeded
// rows carry a bare label or `{value, label}` objects. The readers below must
// tolerate every shape: throwing here unmounts the whole feedback page and
// leaves the visitor with a blank screen.
function parseFeatureJson(raw) {
    if (raw === null || raw === undefined || raw === "") {
        return [];
    }

    let parsed = raw;
    if (typeof raw === "string") {
        try {
            parsed = JSON.parse(raw);
        } catch {
            return [raw];
        }
    }

    if (parsed === null || parsed === undefined) {
        return [];
    }
    return Array.isArray(parsed) ? parsed : [parsed];
}

export function parseFeatureValueList(value) {
    return parseFeatureJson(value).map(optionLabel);
}

export function parseFeatureOptions(featureOptions) {
    return parseFeatureJson(featureOptions).map((option) => ({
        value: option && typeof option === "object" ? option.value : option,
        label: optionLabel(option),
    }));
}

const FEEDBACK_NESTED_SECTIONS = new Set([
    "form",
    "menu",
    "more",
    "share-product",
    "contents",
    "similar",
    "didban-share",
]);

export function getFeedbackRouteId(pathname) {
    const parts = pathname.split("/").filter(Boolean);
    const feedbackIdx = parts.indexOf("feedback");
    if (feedbackIdx === -1) return null;

    const section = parts[feedbackIdx + 1];
    if (!section || section === "400" || section === "500") return null;

    if (FEEDBACK_NESTED_SECTIONS.has(section)) {
        return parts[feedbackIdx + 2] || null;
    }

    return section;
}
